import {
  SegmentedButton as NSegmentedButton,
  type SegmentedButtonProps as NSegmentedButtonProps,
} from '@natera/material/lib/button'
import { cn } from '~/shared/lib/cn'
import './segmented-button.scss'

interface SegmentedButtonProps extends Omit<NSegmentedButtonProps, 'size'> {
  size?: 'small' | 'medium' | 'large'
}

export function SegmentedButton({ className, size, onClick, type, ...rest }: SegmentedButtonProps) {
  return (
    <NSegmentedButton
      {...rest}
      className={cn(
        'c-segmented-button',
        {
          'c-segmented-button--small': size === 'small',
          'c-segmented-button--medium': size === 'medium',
          'c-segmented-button--large': size === 'large',
        },
        className,
      )}
    />
  )
}
